import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetBettieProductsQuery = paths['/api/v1/bettie_products']['get']['parameters']['query'];
export type GetBettieProductsResponse =
  paths['/api/v1/bettie_products']['get']['responses'][200]['content']['application/json']['bettieProducts'];

export async function getBettieProducts(
  params: GetBettieProductsQuery
): Promise<GetBettieProductsResponse> {
  const { data, error } = await client.GET('/api/v1/bettie_products', {
    headers: authHeaders(),
    params: {
      query: params
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting bettie products');
  return data.bettieProducts;
}
